import { QueryClient } from '@tanstack/react-query';
import { attentionApiQueryKeys } from '@/features/dashboard/attention/api/attentionApi.queryKeys.ts';
import { tourAttentionApiQueryKeys } from '@/features/dashboard/tours/api/tourAttentionApi.queryKeys.ts';

/**
 * Po odłożeniu albo przywróceniu sprawy: korzeń modułu (panel spraw całej firmy)
 * i sprawy wyjazdu, jeśli mutacja wie, którego. Bez `tourId` sprawy wyjazdów
 * dogonią same przez `staleTime` — tu nie ma czego zgadywać.
 */
export const invalidateAttentionQueries = (
  queryClient: QueryClient,
  tourId?: string,
): Promise<unknown> => {
  const invalidations = [
    queryClient.invalidateQueries({ queryKey: attentionApiQueryKeys.all() }),
  ];
  if (tourId) {
    invalidations.push(
      queryClient.invalidateQueries({
        queryKey: tourAttentionApiQueryKeys.byTourId(tourId),
      }),
    );
  }
  return Promise.all(invalidations);
};
